import {MouseEventHandler} from 'react';
import {TrackingProps} from '@/components/tracked-atoms/types';
import {analyticsHandler} from '@/services/analytics/analytics-handler';
import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';

export const getTrackedOnClickEvent = <Element extends HTMLElement>(
  trackingKey: TrackingProps['trackingKey'],
  onClick: MouseEventHandler<Element> | undefined,
  getWebClickParams: (
    event: React.MouseEvent<Element, MouseEvent>,
    trackingKey: Exclude<TrackingProps['trackingKey'], typeof WEB_CLICK_TRACKING_KEY.DISABLED>,
  ) => Parameters<typeof analyticsHandler.webClick>[0],
) => {
  return trackingKey === WEB_CLICK_TRACKING_KEY.DISABLED
    ? onClick
    : (event: React.MouseEvent<Element, MouseEvent>) => {
        onClick?.(event);
        analyticsHandler.webClick(getWebClickParams(event, trackingKey));
      };
};
